import type { BasemapRaw } from '@tsyl/karonte/lib/types/basemap'

import Gray from '@/assets/SA_Gray_Thumbnail.png'
import Light from '@/assets/SA_Light_Thumbnail.png'

export default [
  // DEFAULT BASEMAPS
  {
    id: 'imageryHybrid',
    type: 'PortalArcGis',
    title: 'Imagery Hybrid',
    url: 'ff52218580f94d89851563f50cd1a2b2'
  },
  {
    id: 'darkGrayCanvas',
    type: 'PortalArcGis',
    title: 'Dark Gray Canvas',
    url: '358ec1e175ea41c3bf5c68f0da11ae2b',
    customThumbnail: Gray
  },
  {
    id: 'topo',
    type: 'PortalArcGis',
    title: 'Topo',
    url: '7378ae8b471940cb9f9d114b67cd09b8'
  },
  {
    id: 'street',
    type: 'PortalArcGis',
    title: 'Street',
    url: 'bc19c34549de4000bcd91cef929420dc'
  },
  {
    id: 'lightGrayCanvas',
    type: 'PortalArcGis',
    title: 'Light Gray Canvas',
    url: '979c6cc89af9449cbeb5342a439c6a76',
    customThumbnail: Light
  },
  {
    id: 'streetsNight',
    type: 'PortalArcGis',
    title: 'Streets Night',
    url: 'ce493841056a4d1fa497fc5315d54bdc'
  },
  // US BASEMAPS
  {
    id: 'hybridUS',
    type: 'PortalArcGis',
    title: 'Imagery Hybrid',
    url: '0d17ba68a8f64c278e7e2e7864e1069d'
  },
  {
    id: 'imageryUS',
    type: 'PortalArcGis',
    title: 'Imagery',
    url: '86de95d4e0244cba80f0fa2c9403a7b2'
  },
  {
    id: 'streetsNightUS',
    type: 'PortalArcGis',
    title: 'Streets Night',
    url: '93a76c89f9ea4c169f116c0715e37f6f'
  },
  {
    id: 'streetsUS',
    type: 'PortalArcGis',
    title: 'Street',
    url: '22fb75c0fa5a4c88b8ca4c4b8ae5c90b'
  },
  {
    id: 'lightGrayCanvasUS',
    type: 'PortalArcGis',
    title: 'Light Gray Canvas',
    url: 'c5b0e6e1ded840639b8b4ff3d9927145'
  },
  {
    id: 'darkGrayCanvasUS',
    type: 'PortalArcGis',
    title: 'Dark Gray Canvas',
    url: '77b3505cd7ae4484ac3fc253a50ee9c8'
  },
  {
    id: 'topoUS',
    type: 'PortalArcGis',
    title: 'Topo',
    url: '668f436dc2dc4f2c83ceb0c064380590'
  }
] as BasemapRaw[]
